<div #logsContainer class="process-logs-container">
  <ng-container *ngFor="let log of logs$ | async">
    <div class="process-logs-item">{{ log }}</div>
  </ng-container>
</div>
